import { Flex, Text, useToast } from '@chakra-ui/react'
import { useEffect } from 'react'


const handleToast = (
  toast: ReturnType<typeof useToast>,
  success: boolean,
  title: string,
  detail: string,
  time?: number,
) => {
  let toastId: string | number
  const ref = { current: null as null | HTMLDivElement }

  function ToastBox() {
    useEffect(() => {
      function handleClick(event: MouseEvent) {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          toast.close(toastId)
        }
      }
      document.addEventListener('mousedown', handleClick)
      return () => document.removeEventListener('mousedown', handleClick)
    }, [])

    return (
      <Flex
        minH="32px"
        bg={success ? 'success.200' : 'error.100'}
        p="8px"
        borderRadius="8px"
        boxShadow="0px 2px 4px 0px #0000000A"
        ref={ref}
        justify="center"
        w="auto"
      >
        <Flex gap="8px" justifyContent="space-between" align="center">
          <Flex alignItems="center" gap="8px" align="center" w="100%">
            <Flex flexDirection="column" justify="center" gap="2px" align="center" w="100%">
              <Text textStyle="h-xs" color="text.White" textAlign="center">
                {title}
              </Text>
              <Text textStyle="b-xs" color="text.White">
                {detail}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    )
  }

  toastId = toast({
    render: () => <ToastBox />,
    duration: time ? time : 5000,
    isClosable: true,
    position: 'bottom',
  })
}

export default handleToast
